define('container/argResolvers/CookieAccessorArgResolver',['underscore', 'bluebird'], function(_, Promise) {

    'use strict';

    function CookieAccessorArgResolver(cookieAccessorFactoryServiceId, loggerConstructorServiceId) {
        this.cookieAccessorFactoryServiceId = cookieAccessorFactoryServiceId;
        this.loggerConstructorServiceId = loggerConstructorServiceId;
    }

    CookieAccessorArgResolver.prototype.canResolveArg = function(argDefinition) {
        return argDefinition.substr(0, 15) === 'cookieAccessor:';
    };

    CookieAccessorArgResolver.prototype.resolveArg = function(argDefinition, extensionApi) {

        var parts = argDefinition.split(':'),
            name = parts[1],
            container = extensionApi.container,
            config = container.config.cookieAccessors,
            cache = container.cache.cookieAccessors = container.cache.cookieAccessors || {};

        return Promise.all([
            container.get(this.cookieAccessorFactoryServiceId),
            container.get(this.loggerConstructorServiceId)
        ]).spread(function(cookieAccessorFactory, LoggerConstructor) {

            function loadRawAccessor(rawName) {

                if (!cache[rawName]) {

                    cache[rawName] = cookieAccessorFactory(
                        new LoggerConstructor(rawName + 'Cookie'),
                        config.raw[rawName][0],
                        config.raw[rawName][1]
                    );

                }

                return cache[rawName];

            }

            if (!cache[name]) {

                if (config.keyValue[name]) {
                    cache[name] = loadRawAccessor( config.keyValue[name] ).createKeyValueCookieAccessor(name);
                } else {
                    loadRawAccessor(name);
                }

            }

            return cache[name];

        });

    };

    return CookieAccessorArgResolver;
});

